import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import * as $ from "jquery";
import { PagerService } from "../../core/services/pager.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-groupaccess",
  templateUrl: "./groupaccess.component.html",
  styleUrls: ["./groupaccess.component.css"],
})
export class GroupaccessComponent implements OnInit {
  txtGrpid;

  dlstCountries;
  Countries = [];
  Roles = [];
  successfulData;
  GroupAccess;
  grdFRoleModel: any[];
  grdRoleModel: any;
  RoleDropdown;
  RoleData;
  RoleValue;

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  public country = "";
  public Type = "";
  public LoginEnterpriseID = "";
  public Country;
  public DeviceType;
  public Role;

  constructor(
    // private router: Router,
    private capservice: CAPService,
    private pagerService: PagerService
  ) {
    this.country = this.capservice.country;
    this.LoginEnterpriseID = this.capservice.enterpriseid;
    this.Country = this.capservice.country;
    this.Role = this.capservice.Role;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == "undefined") {
      alert("Invalid login");
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    // if(this.Role != "Regional Voice Admin"|| "Global Admin")
    // {
    //   this.router.navigate(['/Home'], {skipLocationChange:true});
    // }
    this.successfulData = {
      Id: "",
      GroupID: "",
      roleId: "",
      roleName: "",
      Country: "",
      DeviceType: "",
    };
    this.GroupAccess = {
      GroupID: "",
      Country: "",
      DeviceType: "",
      roleId: "",
      RoleDesc: "",
      CreateBy: "",
      roleName: "",
    };

    this.CountryList();
    this.GetUserRoles();
    this.GetDetailsInitial("N", "N");
  }
  CountryList() {
    this.capservice.UserAcessCountryList(null, "N").subscribe((data) => {
      this.Countries = data;
    });
  }

  GetUserRoles() {
    this.capservice
      .GetUserAccessDetails("N", "GetUserRoles", this.Role)
      .subscribe((data) => {
        this.Roles = data;
      });
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.accesss = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  ShowData() {
    var Country =
      $("#dlstCountry").val() == "" ? "N" : $("#dlstCountry").val();
    var strParam = $("#txtGrpid").val() == "" ? "N" : $("#txtGrpid").val();
    $("#grdfgroupName").val("");
    $("#grdFRole").val("");
    $("#grdfCountry").val("");
    if (Country == "N" && strParam == "N") {
      alert("Please enter value to search.");
    } else {
      this.capservice
        .GetGroupAccessDetails(strParam, "GetGroupAccessDetails", Country)
        .subscribe((data) => {
          if (data.length > 0) {
            $("#divgroupaccessDetails").css("display", "block");
            this.successfulData = { accesss: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
          } else {
            $("#divgroupaccessDetails").css("display", "none");
            alert("No Records Found");
          }
        });
    }
  }

  clear() {
    $("#grdFRole").val("");
    $("#grdfCountry").val("");
    $("#grdGrpouName").val("");
    $("#grdfgroupName").val("");
    $("#grdRole").val("");
    $("#grdCountry").val("");
    $("#txtGrpid").val("");
    $("#dlstCountry").val("");
    $("#grdFRoleModel").val("");
    this.GroupAccess.DeviceType = "";
    this.grdFRoleModel = [];
    this.GetDetailsInitial("N", "N");
    this.GroupAccess.roleId = "";
  }
  EditAccess(data) {
    this.successfulData.selected = Object.assign({}, data);
    this.successfulData.selected.selectedRoleName =
      this.successfulData.selected.roleName;
  }

  DeleteAccess(idx) {
    this.successfulData.selected = Object.assign({}, idx);
    this.successfulData.selected.CreateBy = this.LoginEnterpriseID;
    this.successfulData.selected.Id =
      this.successfulData.selected.Id.toString();

    this.capservice
      .UpdateGroupDetails(this.successfulData.selected, "DeleteGroupAccess")
      .subscribe((data: any) => {
        alert(data);
        if (data == "Deleted Successfully") {
          this.clear();
        } else {
          this.clear();
        }
      });
  }

  GetDetailsInitial(strParam, strCountry) {
    debugger;
    $("#divgroupaccessDetails").css("display", "block");
    this.capservice
      .GetGroupAccessDetails(strParam, "GetGroupAccessDetails", strCountry)
      .subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { accesss: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
        }
      });
  }

  UpdateAccess(idx) {
    debugger;
    var message = "";
    if ($("#grdGroupName").val() == "") {
      message = "Please Enter Group Id ";
    }
    if (
      this.successfulData.selected.selectedRoleName == "" ||
      this.successfulData.selected.selectedRoleName == null ||
      this.successfulData.selected.selectedRoleName == undefined
    ) {
      message = message + "\n" + "Please Select Role Name";
    }
    if ($("#grdCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdDeviceType").val() == "") {
      message = message + "\n" + "Please Select Device Type";
    }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.accesss[idx] = Object.assign(
        {},
        this.successfulData.selected
      );
      this.successfulData.selected.CreateBy = this.LoginEnterpriseID;
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.RoleDesc =
        this.successfulData.selected.selectedRoleName;
      this.successfulData.selected.roleName =
        this.successfulData.selected.selectedRoleName;
      var item = this.Roles.find(
        (item) =>
          item.roleName === this.successfulData.selected.selectedRoleName
      );
      this.successfulData.selected.roleId = item.roleId; //this.successfulData.selected.selectedRoleId;
      this.capservice
        .UpdateGroupDetails(this.successfulData.selected, "UpdateGroupAccess")
        .subscribe((data: any) => {
          alert(data);
          if (data == "Updated Successfully") {
            this.clear();
          } else {
            this.clear();
          }
        });
    }
  }
  Reset() {
    this.successfulData.selected = {};
    $("#grdGroupName").val("");
    $("#grdRole").val("");
    $("#grdCountry").val("");

    var Country =
      $("#dlstCountry").val() == "" ? this.country : $("#dlstCountry").val();
    var strParam = $("#txtGrpid").val() == "" ? "N" : $("#txtGrpid").val();
    this.GetDetailsInitial("N", "N");
  }
  AddAccess() {
    debugger;
    var message = "";
    if ($("#grdfgroupName").val() == "") {
      message = "Please Enter Group Id ";
    }
    if ($("#grdFRole").val() == "") {
      message = message + "\n" + "Please Select Role";
    }
    if ($("#grdfCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdfDeviceType").val() == "") {
      message = message + "\n" + "Please Select Device Type";
    }
    if (message != "") {
      alert(message);
    } else {
      this.GroupAccess.CreateBy = this.LoginEnterpriseID;
      this.GroupAccess.RoleDesc = $("#grdFRole").find(":selected").text();
      this.capservice
        .UpdateGroupDetails(this.GroupAccess, "InsertGroupAccess")
        .subscribe((data: any) => {
          alert(data);
          if (data == "Inserted Successfully") {
            this.clear();
          } else {
            this.clear();
          }
        });
    }
  }
}
